import ReactDOM from 'react-dom'
import { memo } from 'react'
import classnames from 'classnames'

interface IProps {
	show: boolean
	className?: string
	children: React.ReactNode
	portalNode?: HTMLElement | null
	innerRef?: React.MutableRefObject<HTMLDivElement | null>
}
function Modal({ show = false, className, portalNode, innerRef, children }: IProps) {
	return (
		<>
			{show &&
				ReactDOM.createPortal(
					<div
						ref={innerRef}
						className={classnames(
							' absolute  w-full  h-full outline-none flex flex-col justify-center items-center modal',
							className || 'top-0 left-0',
						)}
						tabIndex={-1}
						role="dialog"
					>
						{children}
					</div>,
					portalNode || document.body,
				)}
		</>
	)
}

export default memo(Modal)
